// extracted by mini-css-extract-plugin
export default {"container":"RecentSearchList__container___qakuR"};